module.exports = __webpack_public_path__ + "img/tool_core.2789411e.png";